var _path, _path2, _path3, _path4, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHidden(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.69,7.37,17.21,8.86A8.26,8.26,0,0,1,19.76,12a8.46,8.46,0,0,1-4.64,4.31,8.57,8.57,0,0,1-5.58.22L7.93,18.14A10.7,10.7,0,0,0,12,19a10.57,10.57,0,0,0,3.84-.72,10.47,10.47,0,0,0,6-5.85L22,12l-.16-.38A10.34,10.34,0,0,0,18.69,7.37Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33,16.62l1.46-1.47A8.31,8.31,0,0,1,4.24,12,8.49,8.49,0,0,1,12,7.11a8.85,8.85,0,0,1,2.48.36l1.61-1.62A10.76,10.76,0,0,0,12,5.05h0a10.51,10.51,0,0,0-9.84,6.57L2,12l.16.39A10.34,10.34,0,0,0,5.33,16.62Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5,11.56a3.27,3.27,0,0,1,0,.44A2.54,2.54,0,0,1,12,14.54a3,3,0,0,1-.43,0L9.93,16.13a4.68,4.68,0,0,0,2.07.5,4.63,4.63,0,0,0,4.13-6.7Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5,12.44a3.27,3.27,0,0,1,0-.44,2.54,2.54,0,0,1,2.21-2.52,1.94,1.94,0,0,0,0,.24,1.68,1.68,0,0,0,.07.5l2.35-2.35A4.67,4.67,0,0,0,12,7.38h0a4.62,4.62,0,0,0-4.13,6.69Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1.1,
    y: 10.96,
    width: 26.19,
    height: 2.08,
    transform: "translate(-4.97 12.01) rotate(-45.02)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidden);
export default __webpack_public_path__ + "static/media/hidden.1a3ac3e751fbd74e64c715ccb4ab258d.svg";
export { ForwardRef as ReactComponent };